import { RootState } from 'utils/interfaces'
import { selectCatalogOperation } from 'utils/selectCatalogOperation'

export const selectRobotTelemetry = (state: RootState) => state.robot.telemetry
export const selectRobotLoadingProgress = (state: RootState) => state.robot.loadingProgress
export const selectRobot = (state: RootState) => state.robot
export const selectRobotJobUploadingProgress = (state: RootState) => state.robot.jobInfo.uploadingProgress
export const selectRobotActiveTask = (state: RootState) => state.robot.robotInfo?.activeTask
export const selectRobotActiveMode = (state: RootState) => state.robot.robotInfo?.activeMode

/** Fields MissionMap needs. Excludes live pose so telemetry ticks do not re-render the mission layers. */
export const selectRobotMapLocalization = (state: RootState) => ({
  robotId: state.robot.robotInfo?.id,
  facilityId: state.robot.robotInfo?.facilityId ?? null,
  vendor: state.robot.robotInfo?.vendor,
  localizationMode: state.robot.telemetry?.localization_info?.localization_mode,
  lidarMapName: state.robot.telemetry?.localization_info?.current_lidar_map,
})

export const selectRobotCatalogOperation = (state: RootState) => selectCatalogOperation(state.robot.robotInfo)
